export default "__VITE_ASSET__BxxrxVfq__"